import { workSheetConstants } from '../../_constants';

const initialState = { getSharedUsersLoading: true, data: '', error: false };

export function getSharedUsersReducer(state = initialState, action) {
    switch (action.type) {
        case workSheetConstants.REQUEST_GET_SHARED_USERS:
            return {
                getSharedUsersLoading: true,
                data: '',
                error: false
            };
        case workSheetConstants.RECEIVE_GET_SHARED_USERS:
            return {
                getSharedUsersLoading: false,
                data: action.getSharedUsers,
                error: false
            };
        case workSheetConstants.GET_SHARED_USERS_ERROR:
            return {
                getSharedUsersLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/workSheet/getSharedUsers.reducer.js